import dayjs from 'dayjs';

export const DASHBOARD_HISTOGRAM = 'DASHBOARD/histogram';
export const DASHBOARD_SCHEME = 'DASHBOARD/scheme';
export const COUNT_CARD = 'DASHBOARD/count_card';

export const TRANSACTION_LIST = 'DASHBOARD/transaction_list';
export const TRANSACTION_SELECTED = 'DASHBOARD/transaction_selected';
export const TRANSACTION_PAGER = 'DASHBOARD/transaction_pager';
export const TRANSACTION_FILTER = 'DASHBOARD/transaction_filter';
export const TRANSACTION_TOTAL = 'DASHBOARD/transaction_total';

export const TRANSACTION_COMPARE = 'DASHBOARD/compare';

export const TRANSACTION_DISPUTE_REQUEST = 'TRANSACTION/request_dispute';

// BILLER DASHBOARD
export const BILLER_COUNT_CARDS = 'DASHBOARD/count_cards';
export const BILLER_TRANSACTION = 'DASHBOARD/transaction';
export const BILLER_BY_AMOUNT = 'DASHBOARD/by_amount';
export const BILLER_COMPARATIVE_TRANSACTION =
  'DASHBOARD/biller_comparative_transaction';

// ORGANIZATION DASHBOARD
export const ORGANIZATION_COUNT_CARDS = 'DASHBOARD/organization_count_cards';
export const ORGANIZATION_TRANSACTION = 'DASHBOARD/organization_transaction';
export const ORGANIZATION_TOP_BILLERS = 'DASHBOARD/organization_top_billers';
export const ORGANIZATION_TOP_BILLER_TYPES =
  'DASHBOARD/organization_top_biller_types';
export const ORGANIZATION_COMPARATIVE_TRANSACTION =
  'DASHBOARD/organization_comparative_transaction';

// COMPARE MODULE
const MAP_KEY = {
  day: 'YYYY-MM-DD',
  month: 'YYYY-MM',
  year: 'YYYY',
};

export const buildId = (date, mode) => {
  if (!date) return null;
  return dayjs(date).format(MAP_KEY[mode]);
};

export const BILLER_TYPE = {
  CORPORATION: 'Corporation',
  SOLE_PROPRIETORSHIP: 'Sole proprietorship/Partnership',
  INDIVIDUAL: 'Individual',
  GOVERNMENT: 'Government',
};
